// Links into SharePoint. A step/phase/grant stores its SPPath as everything below the document
// library ("2022/C06OD032083_TUSKEGEE UNIVERSITY/DC/01 Schematic Design/a - Submission"); the
// library base comes from the server (ClientConfiguration.spFolderBaseUrl) so the site and library
// stay configuration rather than something the app hardcodes per environment.
export const sharePointFolderUrl = (
    folderBaseUrl: string | null | undefined,
    spPath: string | null | undefined
): string | null => {
    if (!folderBaseUrl || !spPath) return null;

    // Segment by segment, so the separators survive the encoding and a space becomes %20.
    const encoded = spPath
        .split("/")
        .filter(segment => segment.length > 0)
        .map(encodeURIComponent)
        .join("/");

    if (!encoded) return null;

    return `${folderBaseUrl.replace(/\/+$/, "")}/${encoded}`;
};
